export default "__VITE_ASSET__B7szRM9R__"